const errorCodes = {
    'case_already_approved': 'Case already approved',
    'case_already_rejected': 'case already rejected',
    'invalid_case_id': 'Invalid case Id',
    'invalid_action_value': 'Invalid action value',
    'no_contactId_information_on_user': 'User definition is missing contact id, contact your administrator',
    'km_value_must_be_greater_or_equal': `New mileage can't be less or equal than last documented mileage`,
}

export default {errorCodes}